/* eslint-disable no-underscore-dangle */
import {
  InvokedAction,
  MasonryActionResult,
} from '#types/masonry-engine-action.types.ts';
import { MasonryEngineNodeAction } from '#types/masonry-engine-node.types.ts';
import { v4 as uuidv4 } from 'uuid';

export const sendActionStartedEventToDevtools = (
  action: InvokedAction<MasonryEngineNodeAction>,
  opts?: { parentActionEventId?: string },
) => {
  const actionEventId = uuidv4();

  const { event, ...sanitizedAction } = action;

  window.__MASONRY_DEVTOOLS__?.onActionEvent({
    kind: 'started',
    id: actionEventId,
    action: sanitizedAction,
    parentActionEventId: opts?.parentActionEventId,
  });

  const sendEnded = (result: MasonryActionResult) => {
    window.__MASONRY_DEVTOOLS__?.onActionEvent({
      kind: 'ended',
      id: actionEventId,
      returnValue: result,
    });
  };

  const sendFailed = (error: unknown) => {
    window.__MASONRY_DEVTOOLS__?.onActionEvent({
      kind: 'failed',
      id: actionEventId,
      error: error instanceof Error ? error.message : undefined,
    });
  };

  return { sendEnded, sendFailed, actionEventId };
};
